// extracted by mini-css-extract-plugin
module.exports = {"container":"OptionContainer_container__1kOyX","heading":"OptionContainer_heading__kNBgs","grid":"OptionContainer_grid__1Qluc","error":"OptionContainer_error__2-NTV"};